export default "__VITE_ASSET__CvPMbOnU__"